module.exports = __webpack_public_path__ + "assets/img/520a523f5f3d6597c22072a69bc2b24a.png";